module.exports = __webpack_public_path__ + "img/3.25fb926b.jpg";